<template>
  <div class="SelectedRoutePoints">
    <div class="level is-mobile SelectedRoutePoints__header">
      <div class="level-left">
        <h2 class="title is-6">Wybrane punkty</h2>
      </div>
      <div class="level-right">
        <b-tag type="is-info">{{ points.length }}</b-tag>
      </div>
    </div>

    <div v-if="!points.length" class="SelectedRoutePoints__empty">
      Kliknij marker na mapie, aby dodać punkt do trasy.
    </div>

    <draggable
        v-else
        :value="points"
        @input="$emit('input', $event)"
        tag="ul"
        handle=".SelectedRoutePoints__drag"
        class="SelectedRoutePoints__list"
    >
      <li
          v-for="(point, index) in points"
          :key="point.key"
          class="SelectedRoutePoints__item"
          :class="{ 'has-conflict': isConflict(point), 'is-permanent': point.isPermanent }"
      >
        <button
            type="button"
            class="button is-small is-white SelectedRoutePoints__drag"
            title="Przenieś"
        >
          <i class="mdi">sort</i>
        </button>
        <span class="SelectedRoutePoints__index">{{ index + 1 }}</span>
        <div class="SelectedRoutePoints__body">
          <div class="SelectedRoutePoints__name">
            <strong>{{ point.name }}</strong>
            <b-tag v-if="point.isPermanent" type="is-warning" size="is-small">punkt stały</b-tag>
            <b-tag v-else type="is-light" size="is-small">zamówienie</b-tag>
          </div>
          <p class="SelectedRoutePoints__address">{{ point.address || 'Brak adresu' }}</p>
          <p v-if="!point.hasCoordinates" class="SelectedRoutePoints__warning">
            <i class="mdi">warning</i> Brak poprawnych wspolrzednych.
          </p>
          <p v-if="getConflict(point)" class="SelectedRoutePoints__conflict">
            {{ formatConflict(getConflict(point)) }}
          </p>
          <p v-if="point.isPermanent">
            <b-field class="SelectedRoutePoints__desc">
              <b-input
                  type="textarea"
                  rows="4"
                  placeholder="Napisz co należy wykonać w tym punkcie..."
                  :value="point.description"
                  @input="updateDescription(point, $event)"
              />
            </b-field>
          </p>
        </div>
        <button
            type="button"
            class="button is-small is-danger is-outlined SelectedRoutePoints__remove"
            @click="$emit('remove', point)"
            title="Usuń punkt"
        >
          <i class="mdi">close</i>
        </button>
      </li>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SelectedRoutePoints',
  components: {
    draggable
  },
  props: {
    points: {
      type: Array,
      required: true
    },
    conflicts: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateDescription(point, description) {
      const updatedPoints = this.points.map(p =>
          p.key === point.key ? { ...p, description } : p
      )
      this.$emit('input', updatedPoints)
    },
    getConflict(point) {
      return this.conflicts.find(conflict => conflict.type === point.type && Number(conflict.id) === point.id)
    },
    isConflict(point) {
      return !!this.getConflict(point)
    },
    formatConflict(conflict) {
      if (!conflict) return ''
      switch (conflict.reason) {
        case 'order_already_assigned':
          return `Zamówienie jest juz w trasie #${conflict.routeId || '-'}`
        case 'order_status_not_plannable':
          return `Status zamówienia nie pozwala na planowanie: ${conflict.status || '-'}`
        case 'permanent_point_inactive':
          return 'Punkt stały jest nieaktywny.'
        default:
          return conflict.reason || 'Punkt nie jest dostępny.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.SelectedRoutePoints {
  &__header {
    margin-bottom: 8px;
  }

  .title {
    margin-bottom: 0;
  }

  &__empty {
    border: 1px dashed #dbdbdb;
    padding: 14px;
    color: #777;
    text-align: center;
  }

  &__list {
    list-style: none;
    margin: 0;
  }

  &__item {
    display: grid;
    grid-template-columns: 34px 28px minmax(0, 1fr) 36px;
    gap: 6px;
    align-items: start;
    padding: 8px 0;
    border-bottom: 1px solid #eee;

    &.is-permanent {
      background: #fffdf0;
    }

    &.has-conflict {
      background: #fff5f5;
    }
  }

  &__drag {
    cursor: move;
  }

  &__drag,
  &__remove {
    width: 30px;
    height: 30px;
    padding: 0;
  }

  &__index {
    font-weight: bold;
    color: #777;
    line-height: 30px;
    text-align: center;
  }

  &__name {
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
  }

  &__address {
    font-size: 12px;
    color: #666;
    margin-top: 2px;
  }

  &__warning,
  &__conflict {
    font-size: 12px;
    margin-top: 4px;
  }

  &__warning {
    color: #946c00;
  }

  &__conflict {
    color: #c0392b;
    font-weight: bold;
  }

  &__desc {
    margin-top: 12px;
  }
}
</style>